import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cpa',
  templateUrl: './cpa.component.html',
  styleUrls: ['./cpa.component.css']
})
export class CpaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
